<div class="account-wrapper">
  <h1>{{ "My Account" | translate }}</h1>
  <div class="sections-wrapper">
    <div class="section">
      <h4 class="title">{{ "About You" | translate }}</h4>
      @if (editFlag) {
        <app-about-you-form
          (onToggle)="toggleEdit($event)"
          (onChange)="updateAccount($event)"
          (formValidity)="setFormValidity($event)"
          [initialValue]="myAccount" />
      } @else {
        <table class="detail-table">
          <tbody>
            <tr>
              <td>
                <h5>{{ "Name" | translate }}</h5>
              </td>
              <td>
                <b>{{ myAccount?.NAME }}</b>
              </td>
            </tr>
            <tr>
              <td>
                <h5>{{ "Username" | translate }}</h5>
              </td>
              <td>
                <b>{{ myAccount?.NAME }}</b>
              </td>
            </tr>
            <tr>
              <td>
                <h5>{{ "E-mail" | translate }}</h5>
              </td>
              <td>
                <b>{{ myAccount?.EMAIL }}</b>
              </td>
            </tr>
            <!--            <tr>-->
            <!--              <td>-->
            <!--                <h5>{{ "Commission" | translate }}</h4>-->
            <!--              </td>-->
            <!--              <td>-->
            <!--                <b>{{ 0 | percent: "1.2-2" }}</b>-->
            <!--              </td>-->
            <!--            </tr>-->
            <tr>
              <td>
                <h5>{{ "Date of Birth" | translate }}</h5>
              </td>
              <td>
                <b>{{ myAccount?.DATEOFBIRTH }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
    <div class="section">
      <h4 class="title">{{ "Contact Details" | translate }}</h4>
      @if (editFlag) {
        <app-contact-details-form
          (onToggle)="toggleEdit($event)"
          (onChange)="updateAccount($event)"
          (formValidity)="setFormValidity($event)"
          [initialValue]="myAccount" />
      } @else {
        <table class="detail-table">
          <tbody>
            <tr>
              <td>
                <h5>{{ "Phone Number" | translate }}</h5>
              </td>
              <td>
                <b>{{ myAccount?.PHONE }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
    <div class="section">
      <h4 class="title">{{ "Address" | translate }}</h4>
      @if (editFlag) {
        <app-address-form (onToggle)="toggleEdit($event)" (onChange)="updateAccount($event)" [initialValue]="myAccount" />
      } @else {
        <table class="detail-table">
          <tbody>
            <tr>
              <td>
                <h5>{{ "Country" | translate }}</h5>
              </td>
              <td>
                <b>{{ getCountry(myAccount?.COUNTRY) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
    @if (!userName.includes("demo")) {
      <div class="section">
        <h4 class="title">{{ "Security Settings" | translate }}</h4>
        <table class="detail-table">
          <tbody>
            <tr>
              <td>
                <h5>{{ "Two-Factor Authentication" | translate }}</h5>
              </td>
              <td>
                <mat-slide-toggle
                  [disabled]="(loading$ | async) || !myAccount"
                  color="primary"
                  [checked]="myAccount?.IS_2FA_ENABLED"
                  (change)="handle2faToggle($event)"></mat-slide-toggle>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="actions">
        <button
          class="edit-btn"
          [color]="editFlag ? 'warn' : 'primary'"
          mat-raised-button
          (click)="handleFlag(!editFlag)"
          [disabled]="loader.state.value['account']">
          @if (editFlag) {
            <span>Cancel</span>
          } @else {
            <span>Edit</span>
          }
        </button>
        @if (editFlag) {
          <button [disabled]="loader.state.value['account'] || !isFormValid" color="primary" mat-raised-button (click)="handleSubmit()">Save</button>
        }
      </div>
    }
    <!--    <div class="section">-->
    <!--      <h4 class="title">{{ "Login History" | translate }}</h4>-->
    <!--      <app-login-history />-->
    <!--    </div>-->
    <!--    <div class="section">-->
    <!--      <h4 class="title">{{ "Feedback" | translate }}</h4>-->
    <!--      <h5>-->
    <!--        {{ "Submit your feedback to" | translate }}-->
    <!--        <a href="mailto:sales@mountbet.com" target="_blank">-->
    <!--          {{ "sales@mountbet.com" }}-->
    <!--        </a>-->
    <!--      </h4>-->
    <!--    </div>-->
  </div>
</div>
